var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "playable-maker-search" }, [_c('i', { staticClass: "icon-search" }), _vm._v(" "), _c('el-schema-form', { attrs: { "model": _vm.model, "schema": _vm.schema, "config": { size: 'mini' } } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };